module.exports = __webpack_public_path__ + "static/media/pin-icon--red.67bdba2a.svg";